// src/context/AuthContext.tsx

import React, { createContext, useState, useEffect, ReactNode } from "react";
import api from "../api/client";

interface AuthContextType {
  isAuthenticated: boolean;
  setIsAuthenticated: (auth: boolean) => void;
  user: any; // 根据你的 JWT payload 结构定义
}

export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  setIsAuthenticated: () => {},
  user: null,
});

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    // 调用后端验证函数，检查用户是否已认证
    const verifyAuth = async () => {
      try {
        const res = await api.get("/verify-token", {
          withCredentials: true, // 确保请求携带 Cookie
        });
        if (res.status === 200 && res.data.user) {
          setIsAuthenticated(true);
          setUser(res.data.user);
        }
      } catch (error) {
        setIsAuthenticated(false);
        setUser(null);
      }
    };

    verifyAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, user }}>
      {children}
    </AuthContext.Provider>
  );
};
